import { render, staticRenderFns } from "./phiFormulaGreater.vue?vue&type=template&id=19ed220d&"
import script from "./phiFormulaGreater.vue?vue&type=script&lang=ts&"
export * from "./phiFormulaGreater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports